import memo from './index.js';
export default function memoize(memoizeOptions = {}) {
    return (target, propertyKey, descriptor) => {
        descriptor.value = memo(descriptor.value, memoizeOptions);
        Object.defineProperty(target, propertyKey, descriptor);
    };
}
